import { type CSSProperties, type FC, useCallback, useState } from "react";

import { Spacing } from "@snapchat/snap-design-system";
import clsx from "clsx";

import { previewContainer, previewImage, previewImageLoading } from "./RemoteAssetPreview.module.css";
import { RemoteAssetTypeIcon } from "./RemoteAssetTypeIcon";

interface RemoteAssetPreviewProps {
    type: string;
    previewImageUrl?: string | null;
    size?: number;
}

export const RemoteAssetPreview: FC<RemoteAssetPreviewProps> = ({ type, previewImageUrl, size = Spacing.XL }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);

    const handleLoad = useCallback(() => {
        setImageLoaded(true);
    }, []);

    const handleError = useCallback(() => {
        setImageError(true);
    }, []);

    const showImage = previewImageUrl && !imageError;

    return (
        <div className={previewContainer} style={{ "--remote-asset-preview-size": `${size}px` } as CSSProperties}>
            {(!showImage || !imageLoaded) && <RemoteAssetTypeIcon type={type} size={size} />}
            {showImage && (
                <img
                    src={previewImageUrl}
                    alt={type}
                    className={clsx(previewImage, !imageLoaded && previewImageLoading)}
                    style={{ "--remote-asset-preview-size": `${size}px` } as CSSProperties}
                    onLoad={handleLoad}
                    onError={handleError}
                />
            )}
        </div>
    );
};
